export default __webpack_public_path__ + "static/step3-05c52fb6dfb100ebbd861caf28b3efe9.webp";